import Service from "../../../Service";
import Axios from "../../../Config/API";
import { IDocumentoProduto } from "../../../../Interfaces/Geral/Documentos/DocumentoProduto/DocumentoProdutoInterfaces";

export async function ListarDocumentosProdutoService(
    idProduto: number,
    FL_DOCUMENTO_FILHO?: boolean
) {
    const urlParams = new URLSearchParams();
    urlParams.append("idProduto", idProduto.toString());
    if (FL_DOCUMENTO_FILHO !== undefined)
        urlParams.append("FL_DOCUMENTO_FILHO", String(FL_DOCUMENTO_FILHO));
    return Service(
        Axios.get<Array<IDocumentoProduto>>(
            "/home/documentoproduto/listardocumentosporproduto?" +
                urlParams.toString()
        )
    );
}

export async function InserirDocumentosPorProdutoService(
    ID_PRODUTO: number,
    DS_DOCUMENTO_PRODUTO: string,
    DS_NOME_ARQUIVO: string,
    ID_TIPO_DOCUMENTO: number,
    DS_LINK_DRIVE: string,
    FL_DESTAQUE: boolean,
    FL_IMG_IMPLANTACAO: boolean,
    DS_TIPO_DOCUMENTO: string,
    FL_DOCUMENTO_FILHO: boolean,
    requestBody: FormData,
    ID_DOCUMENTO_PRODUTO?: number
) {
    return Service(
        Axios.post(
            `/home/documentoproduto/inserirdocumentosporproduto?ID_DOCUMENTO_PRODUTO=${ID_DOCUMENTO_PRODUTO}&ID_PRODUTO=${ID_PRODUTO}&DS_DOCUMENTO_PRODUTO=${DS_DOCUMENTO_PRODUTO}&DS_NOME_ARQUIVO=${DS_NOME_ARQUIVO}&ID_TIPO_DOCUMENTO=${ID_TIPO_DOCUMENTO}&DS_LINK_DRIVE=${DS_LINK_DRIVE}&FL_DESTAQUE=${FL_DESTAQUE}&FL_IMG_IMPLANTACAO=${FL_IMG_IMPLANTACAO}&DS_TIPO_DOCUMENTO=${DS_TIPO_DOCUMENTO}&FL_DOCUMENTO_FILHO=${FL_DOCUMENTO_FILHO}`,
            requestBody
        )
    );
}

export async function RemoverDocumentosPorProdutoService(
    idDocumentoProduto: number
) {
    return Service(
        Axios.delete(
            `/home/documentoproduto/removerdocumentosporproduto?idDocumentoProduto=${idDocumentoProduto}`
        )
    );
}
